import React from "react";

const AccordionOpen = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 34}
      height={height || 34}
      viewBox="0 0 34 34"
      fill="none"
    >
      <g clipPath="url(#clip0_294_5359)">
        <foreignObject x="-7" y="-7" width="48" height="48">
          <div
            xmlns="http://www.w3.org/1999/xhtml"
            style={{
              backdropFilter: "blur(3.5px)",
              clipPath: "url(#bgblur_1_294_5359_clip_path)",
              height: "100%",
              width: "100%",
            }}
          ></div>
        </foreignObject>
        <circle
          data-figma-bg-blur-radius="7"
          cx="17"
          cy="17"
          r="17"
          fill="white"
        />
        <path
          d="M23.2868 14.2859L17 20.4102L10.7132 14.2859C10.62 14.1953 10.5094 14.1234 10.3876 14.0743C10.2659 14.0252 10.1354 14 10.0036 14C9.87179 14 9.74129 14.0252 9.61953 14.0743C9.49777 14.1234 9.38713 14.1953 9.29394 14.2859C9.20075 14.3765 9.12683 14.4841 9.07639 14.6026C9.02596 14.721 9 14.8479 9 14.9761C9 15.1043 9.02596 15.2312 9.07639 15.3496C9.12683 15.468 9.20075 15.5756 9.29394 15.6663L16.2904 22.471C16.3833 22.5621 16.4938 22.6345 16.6156 22.6838C16.7374 22.7332 16.8681 22.7586 17 22.7586C17.1319 22.7586 17.2626 22.7332 17.3844 22.6838C17.5062 22.6345 17.6167 22.5621 17.7096 22.471L24.7061 15.6663C24.8943 15.4832 25 15.235 25 14.9761C25 14.7172 24.8943 14.4689 24.7061 14.2859C24.5178 14.1028 24.2626 14 23.9964 14C23.7303 14 23.475 14.1028 23.2868 14.2859Z"
          fill="#211551"
        />
      </g>
      <defs>
        <clipPath id="bgblur_1_294_5359_clip_path" transform="translate(7 7)">
          <circle cx="17" cy="17" r="17" />
        </clipPath>
        <clipPath id="clip0_294_5359">
          <rect width="34" height="34" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AccordionOpen;
